module.exports = " <div class=\"panel panel-default\"> <div class=panel-heading> <h4 class=panel-title> <a class=accordion-toggle @click=toggleIsOpen()> {{ header }} </a> </h4> </div> <div class=panel-collapse v-el:panel v-show=isOpen transition=collapse> <div class=panel-body> <slot></slot> </div> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/vue-strap/Panel.vue
// module id = 259
// module chunks = 0